<script setup lang="ts">
import { PhMoonStars } from '@phosphor-icons/vue';
</script>

<template>
	<div
		class="rounded border inline-flex flex-nowrap h-7xl items-center font-semibold py-xxs px-xs gap-xxs bg-teal-50 border-teal-200 [&_svg]:fill-teal-600"
	>
		<PhMoonStars weight="fill" />
		<p
			class="text-xs tracking-[-0.24px] font-semibold text-teal-600 !text-nowrap"
		>
			Eid Delivery
		</p>
	</div>
</template>
